import {requestData, receiveData, receiveError } from '../api/http'
import CloudFlyerAPI from '../api/CloudFlyerAPI'

export const CLOUD_ACCOUNTS_PENDING = 'CLOUD_ACCOUNTS_PENDING'
export const CLOUD_ACCOUNTS_SUCCESS = 'CLOUD_ACCOUNTS_SUCCESS'
export const CLOUD_ACCOUNTS_ERROR = 'CLOUD_ACCOUNTS_ERROR'


export const FETCH_OVERVIEW_CHART_PENDING = 'FETCH_OVERVIEW_CHART_PENDING'
export const FETCH_OVERVIEW_CHART_SUCCESS = 'FETCH_OVERVIEW_CHART_SUCCESS'
export const FETCH_OVERVIEW_CHART_ERROR = 'FETCH_OVERVIEW_CHART_ERROR'


export const FETCH_S3_CHART_PENDING = 'FETCH_S3_CHART_PENDING'
export const FETCH_S3_CHART_SUCCESS = 'FETCH_S3_CHART_SUCCESS'
export const FETCH_S3_CHART_ERROR = 'FETCH_S3_CHART_ERROR'


export const FETCH_BUCKET_COST_CHART_PENDING = 'FETCH_BUCKET_COST_CHART_PENDING'
export const FETCH_BUCKET_COST_CHART_SUCCESS = 'FETCH_BUCKET_COST_CHART_SUCCESS'
export const FETCH_BUCKET_COST_CHART_ERROR = 'FETCH_BUCKET_COST_CHART_ERROR'


export const FETCH_EC2_CHART_PENDING = 'FETCH_EC2_CHART_PENDING'
export const FETCH_EC2_CHART_SUCCESS = 'FETCH_EC2_CHART_SUCCESS'
export const FETCH_EC2_CHART_ERROR = 'FETCH_EC2_CHART_ERROR'


export const FETCH_DATA_TRANSFER_CHART_PENDING = 'FETCH_DATA_TRANSFER_CHART_PENDING'
export const FETCH_DATA_TRANSFER_CHART_SUCCESS = 'FETCH_DATA_TRANSFER_CHART_SUCCESS'
export const FETCH_DATA_TRANSFER_CHART_ERROR = 'FETCH_DATA_TRANSFER_CHART_ERROR'


export const FETCH_RDS_CHART_PENDING = 'FETCH_RDS_CHART_PENDING'
export const FETCH_RDS_CHART_SUCCESS = 'FETCH_RDS_CHART_SUCCESS'
export const FETCH_RDS_CHART_ERROR = 'FETCH_RDS_CHART_ERROR'

export const FETCH_DATABASE_COST_CHART_PENDING = 'FETCH_DATABASE_COST_CHART_PENDING'
export const FETCH_DATABASE_COST_CHART_SUCCESS = 'FETCH_DATABASE_COST_CHART_SUCCESS'
export const FETCH_DATABASE_COST_CHART_ERROR = 'FETCH_DATABASE_COST_CHART_ERROR'

export const FETCH_CLOUD_WATCH_CHART_PENDING = 'FETCH_CLOUD_WATCH_CHART_PENDING'
export const FETCH_CLOUD_WATCH_CHART_SUCCESS = 'FETCH_CLOUD_WATCH_CHART_SUCCESS'
export const FETCH_CLOUD_WATCH_CHART_ERROR = 'FETCH_CLOUD_WATCH_CHART_ERROR'


export const FETCH_EFS_CHART_PENDING = 'FETCH_EFS_CHART_PENDING'
export const FETCH_EFS_CHART_SUCCESS = 'FETCH_EFS_CHART_SUCCESS'
export const FETCH_EFS_CHART_ERROR = 'FETCH_EFS_CHART_ERROR'


export const FETCH_EFS_USAGE_PENDING = 'FETCH_EFS_USAGE_PENDING'
export const FETCH_EFS_USAGE_SUCCESS = 'FETCH_EFS_USAGE_SUCCESS'
export const FETCH_EFS_USAGE_ERROR = 'FETCH_EFS_USAGE_ERROR'


export const FETCH_DIRECT_CONNECT_CHART_PENDING = 'FETCH_DIRECT_CONNECT_CHART_PENDING'
export const FETCH_DIRECT_CONNECT_CHART_SUCCESS = 'FETCH_DIRECT_CONNECT_CHART_SUCCESS'
export const FETCH_DIRECT_CONNECT_CHART_ERROR = 'FETCH_DIRECT_CONNECT_CHART_ERROR'


export const FETCH_SUPPORT_CHART_PENDING = 'FETCH_SUPPORT_CHART_PENDING'
export const FETCH_SUPPORT_CHART_SUCCESS = 'FETCH_SUPPORT_CHART_SUCCESS'
export const FETCH_SUPPORT_CHART_ERROR = 'FETCH_SUPPORT_CHART_ERROR'


export const FETCH_ROUTE53_CHART_PENDING = 'FETCH_ROUTE53_CHART_PENDING'
export const FETCH_ROUTE53_CHART_SUCCESS = 'FETCH_ROUTE53_CHART_SUCCESS'
export const FETCH_ROUTE53_CHART_ERROR = 'FETCH_ROUTE53_CHART_ERROR'


export const FETCH_INVOICE_DOWNLOAD_PENDING = 'FETCH_INVOICE_DOWNLOAD_PENDING'
export const FETCH_INVOICE_DOWNLOAD_SUCCESS = 'FETCH_INVOICE_DOWNLOAD_SUCCESS'
export const FETCH_INVOICE_DOWNLOAD_ERROR = 'FETCH_INVOICE_DOWNLOAD_ERROR'


export const FETCH_SERVICES_HISTORY_PENDING = 'FETCH_SERVICES_HISTORY_PENDING'
export const FETCH_SERVICES_HISTORY_SUCCESS = 'FETCH_SERVICES_HISTORY_SUCCESS'
export const FETCH_SERVICES_HISTORY_ERROR = 'FETCH_SERVICES_HISTORY_ERROR'



export const CHANGE_CLOUD_ACCOUNT = 'CHANGE_CLOUD_ACCOUNT'

export const BUCKET_COST_CHANGE_BUCKET = 'BUCKET_COST_CHANGE_BUCKET'
export const BUCKET_COST_CHANGE_USAGE_TYPE = 'BUCKET_COST_CHANGE_USAGE_TYPE'
export const BUCKET_COST_CLEAR_FILTER = 'BUCKET_COST_CLEAR_FILTER'

export const DATABASE_COST_CHANGE_DATABASE = 'DATABASE_COST_CHANGE_DATABASE'
export const DATABASE_COST_CHANGE_USAGE_TYPE = 'DATABASE_COST_CHANGE_USAGE_TYPE'
export const DATABASE_COST_CLEAR_FILTER = 'DATABASE_COST_CLEAR_FILTER'



export function fetchServicesHistory(page, limit, service) {
  return dispatch => {
    dispatch(requestData(FETCH_SERVICES_HISTORY_PENDING));
    CloudFlyerAPI.transfer.history(page, limit, service)
      .then(function(response) {
        dispatch(receiveData(FETCH_SERVICES_HISTORY_SUCCESS, (response||{}).data))
      })
      .catch(function(err){
        dispatch(receiveError(FETCH_SERVICES_HISTORY_ERROR, err))
      })
  }
}


export function fetchCloudAccounts() {
  return dispatch => {
    dispatch(requestData(CLOUD_ACCOUNTS_PENDING))
    CloudFlyerAPI.new_cloud_accounts.all()
      .then(function(response) {
        dispatch(receiveData(CLOUD_ACCOUNTS_SUCCESS, (response||{}).data))
      })
      .catch(function(err){
        dispatch(receiveError(CLOUD_ACCOUNTS_ERROR, err))
      })
  }
}

export function fetchOverviewChart(cloudAccountId, month) {
  return dispatch => {
    dispatch(requestData(FETCH_OVERVIEW_CHART_PENDING));
    CloudFlyerAPI.analytics.AwsAllocationMonthlyCost.GetProductCost(cloudAccountId, month)
      .then(function(response) {
        dispatch(receiveData(FETCH_OVERVIEW_CHART_SUCCESS, (response||{}).data))
      })
      .catch(function(err){
        dispatch(receiveError(FETCH_OVERVIEW_CHART_ERROR, err))
      })
  }
}

export function fetchS3Chart(cloudAccountId, month) {
  return dispatch => {
    dispatch(requestData(FETCH_S3_CHART_PENDING));
    CloudFlyerAPI.analytics.AwsAllocationMonthlyCost.GetAwsS3(cloudAccountId, month)
      .then(function(response) {
        dispatch(receiveData(FETCH_S3_CHART_SUCCESS, (response||{}).data))
      })
      .catch(function(err){
        dispatch(receiveError(FETCH_S3_CHART_ERROR, err))
      })
  }
}


export function fetchBucketCostChart(cloudAccountId, month) {
  return dispatch => {
    dispatch(requestData(FETCH_BUCKET_COST_CHART_PENDING));
    CloudFlyerAPI.analytics.AwsDetailMonthlyCost.GetBucketCost(cloudAccountId, month)
      .then(function(response) {
        dispatch(receiveData(FETCH_BUCKET_COST_CHART_SUCCESS, (response||{}).data))
      })
      .catch(function(err){
        dispatch(receiveError(FETCH_BUCKET_COST_CHART_ERROR, err))
      })
  }
}



export function fetchEC2Chart(cloudAccountId, month) {
  return dispatch => {
    dispatch(requestData(FETCH_EC2_CHART_PENDING));
    CloudFlyerAPI.analytics.AwsAllocationMonthlyCost.GetAwsEC2(cloudAccountId, month)
      .then(function(response) {
        dispatch(receiveData(FETCH_EC2_CHART_SUCCESS, (response||{}).data))
      })
      .catch(function(err){
        dispatch(receiveError(FETCH_EC2_CHART_ERROR, err))
      })
  }
}


export function fetchDataTransferChart(cloudAccountId, month) {
  return dispatch => {
    dispatch(requestData(FETCH_DATA_TRANSFER_CHART_PENDING));
    CloudFlyerAPI.analytics.AwsAllocationMonthlyCost.GetAwsDataTransfer(cloudAccountId, month)
      .then(function(response) {
        dispatch(receiveData(FETCH_DATA_TRANSFER_CHART_SUCCESS, (response||{}).data))
      })
      .catch(function(err){
        dispatch(receiveError(FETCH_DATA_TRANSFER_CHART_ERROR, err))
      })
  }
}


export function fetchRDSChart(cloudAccountId, month) {
  return dispatch => {
    dispatch(requestData(FETCH_RDS_CHART_PENDING));
    CloudFlyerAPI.analytics.AwsAllocationMonthlyCost.GetAwsRDS(cloudAccountId, month)
      .then(function(response) {
        dispatch(receiveData(FETCH_RDS_CHART_SUCCESS, (response||{}).data))
      })
      .catch(function(err){
        dispatch(receiveError(FETCH_RDS_CHART_ERROR, err))
      })
  }
}


export function fetchDatabaseCostChart(cloudAccountId, month) {
  return dispatch => {
    dispatch(requestData(FETCH_DATABASE_COST_CHART_PENDING));
    CloudFlyerAPI.analytics.AwsDetailMonthlyCost.GetRDSCost(cloudAccountId, month)
      .then(function(response) {
        dispatch(receiveData(FETCH_DATABASE_COST_CHART_SUCCESS, (response||{}).data))
      })
      .catch(function(err){
        dispatch(receiveError(FETCH_DATABASE_COST_CHART_ERROR, err))
      })
  }
}


export function fetchCloudWatchChart(cloudAccountId, month) {
  return dispatch => {
    dispatch(requestData(FETCH_CLOUD_WATCH_CHART_PENDING));
    CloudFlyerAPI.analytics.AwsAllocationMonthlyCost.GetAwsCloudWatch(cloudAccountId, month)
      .then(function(response) {
        dispatch(receiveData(FETCH_CLOUD_WATCH_CHART_SUCCESS, (response||{}).data))
      })
      .catch(function(err){
        dispatch(receiveError(FETCH_CLOUD_WATCH_CHART_ERROR, err))
      })
  }
}


export function fetchEFSChart(cloudAccountId, month) {
  return dispatch => {
    dispatch(requestData(FETCH_EFS_CHART_PENDING));
    CloudFlyerAPI.analytics.AwsAllocationMonthlyCost.GetAwsEFS(cloudAccountId, month)
      .then(function(response) {
        dispatch(receiveData(FETCH_EFS_CHART_SUCCESS, (response||{}).data))
      })
      .catch(function(err){
        dispatch(receiveError(FETCH_EFS_CHART_ERROR, err))
      })
  }
}


export function fetchEFSUsage(cloudAccountId) {
  return dispatch => {
    dispatch(requestData(FETCH_EFS_USAGE_PENDING));
    CloudFlyerAPI.analytics.AwsEFS.GetEFSInstance(cloudAccountId)
      .then(function(response) {
        dispatch(receiveData(FETCH_EFS_USAGE_SUCCESS, (response||{}).data||[]))
      })
      .catch(function(err){
        dispatch(receiveError(FETCH_EFS_USAGE_ERROR, err))
      })
  }
}


export function fetchDirectConnectChart(cloudAccountId, month) {
  return dispatch => {
    dispatch(requestData(FETCH_DIRECT_CONNECT_CHART_PENDING));
    CloudFlyerAPI.analytics.AwsAllocationMonthlyCost.GetAWSDirectConnect(cloudAccountId, month)
      .then(function(response) {
        dispatch(receiveData(FETCH_DIRECT_CONNECT_CHART_SUCCESS, (response||{}).data))
      })
      .catch(function(err){
        dispatch(receiveError(FETCH_DIRECT_CONNECT_CHART_ERROR, err))
      })
  }
}


export function fetchSupportChart(cloudAccountId, month) {
  return dispatch => {
    dispatch(requestData(FETCH_SUPPORT_CHART_PENDING));
    CloudFlyerAPI.analytics.AwsAllocationMonthlyCost.GetAWSSupportBusiness(cloudAccountId, month)
      .then(function(response) {
        dispatch(receiveData(FETCH_SUPPORT_CHART_SUCCESS, (response||{}).data))
      })
      .catch(function(err){
        dispatch(receiveError(FETCH_SUPPORT_CHART_ERROR, err))
      })
  }
}


export function fetchRoute53Chart(cloudAccountId, month) {
  return dispatch => {
    dispatch(requestData(FETCH_ROUTE53_CHART_PENDING));
    CloudFlyerAPI.analytics.AwsAllocationMonthlyCost.GetAwsRoute53(cloudAccountId, month)
      .then(function(response) {
        dispatch(receiveData(FETCH_ROUTE53_CHART_SUCCESS, (response||{}).data))
      })
      .catch(function(err){
        dispatch(receiveError(FETCH_ROUTE53_CHART_ERROR, err))
      })
  }
}


export function fetchInvoiceDownload(cloudAccountId, billingBucket) {
  return dispatch => {
    dispatch(requestData(FETCH_INVOICE_DOWNLOAD_PENDING));
    CloudFlyerAPI.storages.getFilesByPath(cloudAccountId, billingBucket, 100, null)
      .then(function(response) {
        dispatch(receiveData(FETCH_INVOICE_DOWNLOAD_SUCCESS, (response||{}).data))
      })
      .catch(function(err){
        dispatch(receiveError(FETCH_INVOICE_DOWNLOAD_ERROR, err))
      })
  }
}



export function changeCloudAccount(data) {
  return {
    type: CHANGE_CLOUD_ACCOUNT,
    data: data
  }
}


export function changeBucketCostBucket(data) {
  return {
    type: BUCKET_COST_CHANGE_BUCKET,
    data: data
  }
}

export function changeBucketCostUsageType(data) {
  return {
    type: BUCKET_COST_CHANGE_USAGE_TYPE,
    data: data
  }
}

export function clearFilterBucketCost() {
  return {
    type: BUCKET_COST_CLEAR_FILTER,
    data: 0
  }
}


export function changeDatabaseCostDatabase(data) {
  return {
    type: DATABASE_COST_CHANGE_DATABASE,
    data: data
  }
}

export function changeDatabaseCostUsageType(data) {
  return {
    type: DATABASE_COST_CHANGE_USAGE_TYPE,
    data: data
  }
}

export function clearFilterDatabaseCost() {
  return {
    type: DATABASE_COST_CLEAR_FILTER,
    data: 0
  }
}
